import { Placement } from 'react-joyride';
import { BaseTour } from '../types';

export class AuditLandingTour extends BaseTour {
  id = 'audit-landing';
  placement: Placement = 'bottom';

  steps = {
    title: () => ({
      content: 'Welcome to Audit Exceptions! Here you can review and manage financial discrepancies in your invoices.',
    }),
    sortDropdown: () => ({
      content: 'Use this dropdown to sort exceptions by urgency, date, or service provider.',
    }),
    category: () => ({
      content: 'Exceptions are grouped by modality (AIR, ROAD, etc.). Click to expand and see specific service providers.',
    }),
    card: () => ({
      content: 'Each card represents a service provider with pending audits. Click a card to dive into the details.',
    }),
  } as const;
}
